export default defineNuxtRouteMiddleware((to, from) => {
  const url = useRequestURL()
  if (url.host === 'istituto-canossiano.netlify.app') {
    const nextRoute = `${process.env.BASE_URL}${to.fullPath}`
    return navigateTo(nextRoute, { external: true, redirectCode: 301 })
  }
})
